// extracted by mini-css-extract-plugin
export default {"container":"ExpensesCategoriesChart_container__Rh4BW","card":"ExpensesCategoriesChart_card__+IE3A","emptyCard":"ExpensesCategoriesChart_emptyCard__P0BTH"};